import { AuthProductName, ViewName } from '@/types'

const thermalDecorations = {
  id: 'thermal',
  name: 'Thermal',
  viewDecorations: [
    {
      badgeText: '',
      viewName: ViewName.Login,
      offerMessage: '',
      title: 'Log in to your account',
      body: 'Enter the email address associated with your account.'
    },
    {
      badgeText: '',
      viewName: ViewName.Success,
      offerMessage: '',
      title: "You're logged in!",
      body: 'Now open Thermal.'
    }
  ],
  authProductName: AuthProductName.WEBSITE
}
export default thermalDecorations
